import React, {Component} from 'react';
import Homepage from "./pages/Homepage";
import 'antd/dist/antd.css';
import About from "./pages/About";
import Products from "./pages/Products";
import Partners from "./pages/Partners";
import Contacts from "./pages/Contacts";
import {
    ScrollingProvider,
    Section,
} from 'react-scroll-section';


export default class App extends Component {
    render() {
        return (
            <ScrollingProvider>
                <Section id="home">
                    <Homepage/>
                </Section>
                <Section id="about">
                    <About/>
                </Section>
                <Section id="products">
                    <Products/>
                </Section>
                <Section id="partners">
                    <Partners/>
                </Section>
                <Section id="contacts">
                    <Contacts/>
                </Section>
            </ScrollingProvider>
        )
    }
}
